module.exports = __webpack_public_path__ + "static/media/background-image3.0079d1ac.png";